<template>
  <div
    class="sidebar-form-group"
    data-test="graphics-boxShadowSettings"
  >
    <label class="checkbox header-checkbox"
      >Shadow
      <input
        v-model="boxShadow"
        type="checkbox"
        data-test="graphics-boxShadowSettings-toggleBoxShadow"
      />
      <div class="checkmark">
        <span class="checkmark-tick fa-solid fa-check"></span>
      </div>
    </label>

    <template v-if="boxShadow">
      <div class="settings-row settings-row-xs">
        <div class="settings-col-4 settings-col-xs">
          <validation-field as="input"
            v-model.number="boxShadowX"
            rules="required|between:-30,30"
            type="number"
            name="boxShadowX"
            min="-30"
            max="30"
            :class="{ 'is-invalid': validationErrors['boxShadowX'] }"
            data-test="graphics-boxShadowSettings-setX"
            data-entity="graphics-boxShadowSettings-setX"
          />
          <label class="sidebar-input-sub-label">X</label>
        </div>
        <div class="settings-col-4 settings-col-xs">
          <validation-field as="input"
            v-model.number="boxShadowY"
            rules="required|between:-30,30"
            type="number"
            name="boxShadowY"
            min="-30"
            max="30"
            :class="{ 'is-invalid': validationErrors['boxShadowY'] }"
            data-test="graphics-boxShadowSettings-setY"
            data-entity="graphics-boxShadowSettings-setY"
          />
          <label class="sidebar-input-sub-label">Y</label>
        </div>
        <div class="settings-col-4 settings-col-xs">
          <validation-field as="input"
            v-model.number="boxShadowBlur"
            rules="required|between:-30,30"
            type="number"
            name="boxShadowBlur"
            min="-30"
            max="30"
            :class="{ 'is-invalid': validationErrors['boxShadowBlur'] }"
            data-test="graphics-boxShadowSettings-setBlur"
            data-entity="graphics-boxShadowSettings-setBlur"
          />
          <label class="sidebar-input-sub-label">Blur</label>
        </div>
      </div>

      <div class="settings-row settings-row-xs">
        <div class="settings-col-4 settings-col-xs">
          <validation-field as="input"
            v-model.number="boxShadowSpread"
            rules="required|between:-30,30"
            type="number"
            name="boxShadowSpread"
            min="-30"
            max="30"
            :class="{ 'is-invalid': validationErrors['boxShadowSpread'] }"
            :disabled="dropShadow"
            data-test="graphics-boxShadowSettings-setSpread"
            data-entity="graphics-boxShadowSettings-setSpread"
          />
          <label class="sidebar-input-sub-label">Spread</label>
        </div>
        <div class="settings-col-8 settings-col-xs colorpicker">
          <colorpicker
            v-model="boxShadowColor"
            :is-mapped="checkMapped('boxShadowColor')"
          />
          <label class="sidebar-input-sub-label">
            Color
            <span
              data-balloon="This setting is controlled by data. Unmap data to customize."
              data-balloon-pos="down"
              data-balloon-length="medium"
            >
              <span
                v-if="checkMapped('boxShadowColor')"
                class="fa fa-lock mapped-lock"
                data-test="graphics-boxShadowSettings-lockColor"
              />
            </span>
          </label>
        </div>
      </div>

      <div class="sidebar-form-group">
        <label class="checkbox">
          Experimental Drop Shadows
          <input v-model="dropShadow" type="checkbox" data-test="boxshadow-input-dropshadow" />
          <div class="checkmark">
            <span class="checkmark-tick fa-solid fa-check"></span>
          </div>
        </label>
      </div>

      <!-- TODO: remove once sheets can have more than one thing mapped -->
      <div v-if="showDataMapControls">
        <p
          v-if="checkMapped('boxShadowColor')"
          class="sidebar-form-label margin-bottom-sm"
          data-test="graphics-boxShadowSettings-mappedLabel"
        >
          From Data Provider
        </p>
        <map-data-control
          :data-provider="dataProvider"
          :scroll-offset="scrollOffset"
          :element="element"
          property="boxShadowColor"
          :mapped="checkMapped('boxShadowColor')"
          @update-map="mapToField"
          @clear-map="clearMapping"
        />
      </div>
    </template>

  </div>
</template>

<script>
import SettingsMixins from '../../mixins/settings-mixins';
import MapDataControl from './Data/MapDataControl.vue';

export default {
  components: {
    MapDataControl,
  },
  mixins: [SettingsMixins],
  props: ['element', 'scrollOffset'],
  computed: {
    boxShadow: {
      get() {
        return this.getPropertyValue('boxShadow');
      },
      set(v) {
        this.updateOneElementValue('boxShadow', v);
      },
    },
    boxShadowX: {
      get() {
        return this.getPropertyValue('boxShadowX');
      },
      set(v) {
        this.updateOneElementValue('boxShadowX', v);
      },
    },
    boxShadowY: {
      get() {
        return this.getPropertyValue('boxShadowY');
      },
      set(v) {
        this.updateOneElementValue('boxShadowY', v);
      },
    },
    boxShadowBlur: {
      get() {
        return this.getPropertyValue('boxShadowBlur');
      },
      set(v) {
        this.updateOneElementValue('boxShadowBlur', v);
      },
    },
    boxShadowSpread: {
      get() {
        return this.getPropertyValue('boxShadowSpread');
      },
      set(v) {
        this.updateOneElementValue('boxShadowSpread', v);
      },
    },
    boxShadowColor: {
      get() {
        return this.getPropertyValue('boxShadowColor', { mappedPath: 'boxShadowColor' });
      },
      set(v) {
        this.updateOneElementValue('boxShadowColor', v);
      },
    },
    dropShadow: {
      get() {
        return this.getPropertyValue('dropShadow');
      },
      set(v) {
        this.updateOneElementValue('dropShadow', v);
      },
    },
  },
};
</script>
